import { getMessages } from '../../../../../../../store/constants';

export const SHOW_ON_GANTT = getMessages().getText('card_form_show_on_gantt');
export const SHOW_ON_GANTT_TOOLTIP = getMessages().getText('card_form_show_on_gantt_tooltip');
export const HIDE_FROM_GANTT_TOOLTIP = getMessages().getText('card_form_hide_from_gantt_tooltip');
export const SHOW_ON_GANTT_HINT = getMessages().getText('gantt_context_hints.show_on_gantt');
